import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SecurityHelper } from '../pages/common/securityHelper';

const HTTP_RESPONSE_TRANSFORMATION_APPLIED = "214";

@Injectable()
export class ResponseModifierInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          // Modify the response body here
          const modifiedBody = this.modifyBody(event.body);
          // Clone the response and set the modified body
          return event.clone({ body: modifiedBody });
        }
        return event;
      })
    );
  }

  private modifyBody(body: any): any {

    if (body.statusMessage) {
      if (body.statusMessage == HTTP_RESPONSE_TRANSFORMATION_APPLIED) {
        SecurityHelper.decryptAPIResponseAuthorized(body);
      }
    }

    return body;
  }
}
